export default __webpack_public_path__ + "static/media/SupplierShed.61889b8a.jpg";